import { render, staticRenderFns } from "./tab-list.vue?vue&type=template&id=38a81b8e&"
import script from "./tab-list.vue?vue&type=script&lang=js&"
export * from "./tab-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports